// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestCorrectionReviewResolveBody = {
  poolId: string;
  contestId: string;
  roundId: string;
  resultsDigest: string;
  reviewToken: string;
  decision: "reject" | "editAndApply";
  reason: string;
  entries: {
    entryId: string;
    status: "in" | "eliminated" | "revived";
    livesRemaining: number;
    pointsTotal: number;
  }[];
};

export type typeContestCorrectionReviewResolveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { contestId: string; roundId: string; resolvedAt: string };
};

export type typeContestCorrectionReviewResolveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestCorrectionReviewResolveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestCorrectionReviewResolveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestCorrectionReviewResolveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", minLength: 1, maxLength: 3000 },
    contestId: { type: "string", minLength: 1, maxLength: 3000 },
    roundId: { type: "string", minLength: 1, maxLength: 3000 },
    resultsDigest: { type: "string", minLength: 1, maxLength: 3000 },
    reviewToken: { type: "string", minLength: 1, maxLength: 3000 },
    decision: { type: "string", enum: ["reject", "editAndApply"] },
    reason: { type: "string", minLength: 1, maxLength: 3000 },
    entries: {
      type: "array",
      items: {
        type: "object",
        properties: {
          entryId: { type: "string", minLength: 1, maxLength: 3000 },
          status: { type: "string", enum: ["in", "eliminated", "revived"] },
          livesRemaining: { type: "integer" },
          pointsTotal: { type: "integer" },
        },
        required: ["entryId", "status", "livesRemaining", "pointsTotal"],
      },
    },
  },
  required: [
    "poolId",
    "contestId",
    "roundId",
    "resultsDigest",
    "reviewToken",
    "decision",
    "reason",
    "entries",
  ],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestCorrectionReviewResolve(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestCorrectionReviewResolveBody);
  }

  return async function postContestCorrectionReviewResolve(
    payload: typeContestCorrectionReviewResolveBody,
  ): Promise<
    | typeContestCorrectionReviewResolveOutput200
    | typeContestCorrectionReviewResolveOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestCorrectionReviewResolve" failed before calling the network. #997e82fd6c4f`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#997e82fd6c4f" },
        },
        data: null,
      } as typeContestCorrectionReviewResolveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/correction-review-resolve`,
      httpMethod: "POST",
      options,
    })) as
      | typeContestCorrectionReviewResolveOutput200
      | typeContestCorrectionReviewResolveOutput400;
  };
}
